import React, { useContext, useState, useEffect } from 'react'

import { Input } from 'antd'
import { useSelector } from 'react-redux'

import { validateFormInput } from '../../../utils'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'
import { selectUser } from '../../../reducers/UserReducer'
import { connect, mapDispatchToProps, mapStateToProps } from '../../../reducers/Dispatchers'

const CustomInput = props => {
  const { institution } = useContext(InstitutionContext)

  const user = useSelector(selectUser)

  const [value, setValue] = useState()

  useEffect(() => {
    if (props[props.getter]) {
      setValue(props.dataId === null ? props[props.getter] : props[props.getter][props.dataId])
    }
  }, [props.dataId === null ? props[props.getter] : props[props.getter][props.dataId]])

  const onDataEdit = (newValue) => {
    const valueCopy = { ...value }

    valueCopy[props.columnKey] = newValue

    setValue(valueCopy)
  }

  const onBlur = () => {
    if (props.dataId === null) {
      props[props.setter](value)
    } else {
      const badgesAssignations = { ...props[props.getter] }

      badgesAssignations[props.dataId] = value

      props[props.setter](badgesAssignations)
      props[props.setDirty](props.dataId)
    }

    if (props.fetchRfidNumber && validateFormInput('freeText', value.badgeNumber)) {
      props.fetchBadgeRFIDNumber(institution.id, value.badgeNumber, user, props.dataId)
    }
  }

  const handleFocus = props.cleanTimeOut

  return (
    <Input
      value={value ? value[props.columnKey] : undefined}
      placeholder={props.t('Empty')}
      onChange={e => onDataEdit(e.target.value)}
      onBlur={onBlur}
      onFocus={handleFocus}
    />
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomInput)
